<template>
    <v-container class="fill-height align-start flex-column" fluid>

		<table class="table" v-if="device">
			<colgroup>
				<col class="col1" />
				<col class="col2" />
			</colgroup>
			<tbody>
				<tr>
					<td colspan="2" class="td-head">
						<div class="head-inner">
							<div class="head-func">
								<v-btn-toggle dense tile borderless mandatory v-model="viewType" color="orange">
									<v-btn class="px-4" value="stream">{{$vuetify.lang.t('$vuetify.tvsm.menu.realtime')}}</v-btn>
									<v-btn class="px-4" value="history">{{$vuetify.lang.t('$vuetify.tvsm.menu.history')}}</v-btn>
								</v-btn-toggle>

								<div v-if="viewType === 'history'" class="d-flex align-center">
									<v-menu v-model="search.menu" offset-y
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										min-width="auto">
										<template v-slot:activator="{on, attrs}">
											<v-text-field readonly hide-details solo dense
												v-model="search.date"
												v-bind="attrs"
												v-on="on"
												label="검색날짜"
												class="mx-4"
											/>
										</template>
										<v-date-picker
											v-model="search.date"
											@input="search.menu = false"
										/>
									</v-menu>
									<v-btn dense tile color="primary" @click="onSearchButtonClickHandler()">
										{{$vuetify.lang.t('$vuetify.common.search')}}
									</v-btn>
								</div>
							</div>

							<div class="head-func">
								<div class="label-top timeinfo hover-item" @click="closeDetail()">
									<v-icon>mdi-close</v-icon>
								</div>
							</div>
						</div>
					</td>
				</tr>
				<tr>
					<td class="td-mid-lt">
						<div class="col-data" :style="ecg1Styles">
							<div class="data-icon"><i class="icon-ecg"></i></div>
							<div class="data-unit">HR</div>
							<div class="data-data">{{values.ecg.hr}}</div>
							<div class="data-min">{{device.ecg_param_min}}</div>
							<div class="data-label">ECG</div>
							<div class="data-max">{{device.ecg_param_max}}</div>
						</div>

						<div class="col-data" :style="spo2Styles">
							<div class="data-icon"><i class="icon-spo"></i></div>
							<div class="data-unit">PR</div>
							<div class="data-data">{{values.spo2.s}}</div>
							<div class="data-min">{{device.spo2_param_min}}</div>
							<div class="data-label">SpO2</div>
							<div class="data-max">{{device.spo2_param_max}}</div>
						</div>

						<div class="col-data" :style="respStyles">
							<div class="data-icon"><i class="icon-resp"></i></div>
							<div class="data-unit">RR</div>
							<div class="data-data">{{values.ecg.rr}}</div>
							<div class="data-min">{{device.resp_param_min}}</div>
							<div class="data-label">RESP</div>
							<div class="data-max">{{device.resp_param_max}}</div>
						</div>

						<div class="col-data" :style="tempStyles">
							<div class="data-icon"><i class="icon-temp"></i></div>
							<div class="data-unit"></div>
							<div class="data-data">{{values.temp.i}}.{{values.temp.d}}<span>℃</span></div>
							<div class="data-min">{{device.temp_param_min}}</div>
							<div class="data-label">TEMP</div>
							<div class="data-max">{{device.temp_param_max}}</div>
						</div>
					</td>
					<td class="td-mid-rt">
						<div class="main-view">
							<template v-if="device">
								<smoothie-chart v-if="viewType === 'stream'" ref="chart" :device="device" />
								<sensor-history v-else-if="viewType === 'history'" :date="search.date" :device="device" ref="sensortable" />
							</template>
						</div>

						<div class="bottom-toolbox">
							<div class="col-nibp" :style="nibpStyles">
								<div class="nibp-icon-title"><i class="icon-nibp"></i> NIBP </div>
								<div class="nibp-data-wrap sys">
									<div class="nibp-data">{{values.nibp.s}}</div>
									<div class="nibp-minmax">{{device.nibp1_min}}/{{device.nibp1_max}}</div>
									<div class="nibp-label">SYS</div>
								</div>
								
								<div class="nibp-data-wrap map">
									<div class="nibp-data">{{values.nibp.m}}</div>
									<div class="nibp-minmax">{{device.nibp2_min}}/{{device.nibp2_max}}</div>
									<div class="nibp-label">MAP</div>
								</div>

								<div class="nibp-data-wrap dia">
									<div class="nibp-data">{{values.nibp.d}}</div>
									<div class="nibp-minmax">{{device.nibp3_min}}/{{device.nibp3_max}}</div>
									<div class="nibp-label">DIA</div>
								</div>
								
								<div class="nibp-data-wrap mmhg">
									<div class="nibp-label">mmHg</div>
									<div class="nibp-data">{{values.nibp.cp}}</div>
								</div>
								
								<div class="nibp-data-wrap hr">
									<div class="nibp-label">HR</div>
									<div class="nibp-data">0</div>
								</div>
							</div>

							<button type="button" class="btn-nibp-refresh" :style="nibpStyles"><i class="icon-refresh" :style="nibpStyles"></i></button>
							<button type="button" class="btn-nibp-refresh" :style="nibpStyles" @click="startCall()">VIDEO</button>

						</div>
					</td>
				</tr>
			</tbody>
		</table>

		<div class="video-call" 
			v-show="onVideoCall"
			:class="{fullscreen, localview}" 
			:style="videoCallStyles">
			<v-btn icon class="vc-btn vc-btn-win-move" @mousedown="startVideoCallDrag">
				<v-icon>mdi-cursor-move</v-icon>
			</v-btn>
			<v-btn icon class="vc-btn vc-btn-move" @click="localview = !localview">
				<v-icon>mdi-video-switch</v-icon>
			</v-btn>
			<v-btn icon class="vc-btn vc-btn-fullscreen" @click="fullscreen = !fullscreen">
				<v-icon v-if="fullscreen">mdi-fullscreen-exit</v-icon>
				<v-icon v-else>mdi-fullscreen</v-icon>
			</v-btn>
			<v-btn icon class="vc-btn vc-btn-close" @click="hangout">
				<v-icon>mdi-close</v-icon>
			</v-btn>
			<div class="video-wrap">
				<video ref="remotev" class="remotev" playsinline autoplay @resize="videoResizeHandler" />
				<video ref="localv" class="localv" playsinline autoplay muted />
			</div>

			<div class="resize-handle resize-handle-width" @mousedown.prevent="videoPanelResizeHandler(1, $event)"></div>
			<div class="resize-handle resize-handle-height" @mousedown.prevent="videoPanelResizeHandler(2, $event)"></div>
			<div class="resize-handle resize-handle-both" @mousedown.prevent="videoPanelResizeHandler(3, $event)"></div>
		</div>
    </v-container>
</template>

<script>
import moment from 'moment'
import adapter from 'webrtc-adapter'
import SmoothieChart from '@/components/SmoothieChart'
import SensorHistory from '@/components/SensorHistory'

export default {
	props: ['serial'],
	components: {SmoothieChart, SensorHistory},
	methods: {
		async getPatient () {
			let {data} = await this.$sock(`device/serial/${this.serial}`)
			if (!data.device) {
				alert(this.$vuetify.lang.t('$vuetify.tvsm.alert.noConnection'))
				window.close()
				return;
			}

			// 기본값 설정
			data.device = Object.assign({
				ecg1_min: '100', ecg1_max: '200', ecg1_color: '#70ad47', 
				ecg2_min: '100', ecg2_max: '200', ecg2_color: '#70ad47',
				spo2_min: '85', spo2_max: '95', spo2_color: '#4472c4',
				resp_min: '30', resp_max: '100', resp_color: '#d29500',
				temp_min: '30', temp_max: '100', temp_color: '#ff0066',
				nibp1_min: '10', nibp1_max: '120', nibp2_min: '10', nibp2_max: '120', nibp3_min: '10', nibp3_max: '120', 
				nibp_color: '#b212be',

				ecg_param_min: 0, ecg_param_max: 100, ecg_graph_min: 0, ecg_graph_max: 100, ecg_wave_speed: 20, ecg_color: '#70ad47',
				spo2_param_min: 0, spo2_param_max: 100, spo2_graph_min: 0, spo2_graph_max: 100, spo2_wave_speed: 20,
				resp_param_min: 0, resp_param_max: 100, resp_graph_min: 0, resp_graph_max: 100, resp_wave_speed: 20
			}, data.device)

			// console.log(data.device)
			this.device = data.device
		},
		subscribe () {
			let topic = `/sensor/${this.serial}`
			this.$session.subscribe(topic, this.subscribeDataHandler.bind(this))
		},
		unsubscribe () {
			let topic = `/sensor/${this.serial}`
			this.$session.unsubscribe(topic)
		},
		subscribeDataHandler (data) {
			if (!this.$refs.chart) return
			try {
				const raw = JSON.parse('[' + data.replace(/&/g, ',') + ']')
				for (let t of raw) {
					if (t.t.endsWith('wave')) this.$refs.chart.append(t)
					else {
						if (t.t in this.values) {
							Object.assign(this.values[t.t], t.d)
						}
					}
				}
			}
			catch (ex) {
				console.log(ex.message)
				console.log(data)
			}
		},
		setView (view) {
			this.view = view
		},
		startCall () {
			this.fullscreen = false
			this.localview = false
			this.onVideoCall = true
			this.rtc.device = this.device
			this.$session.$on('ring', this.processCall.bind(this))
			this.$session.send('ring', this.rtc.device.serial_name)
		},
		async processCall () {
			this.$session.$off('ring')
			if (this.reservedConsult) {
				let serial = this.rtc.device.serial_name
				this.$session.send('reserved', {id: this.reservedConsult, serial})
			}

			this.rtc.pc = new RTCPeerConnection(this.rtc.configuration)
			this.rtc.pc.addEventListener('icecandidate', (evt) => {
			if (evt.candidate) {
				if (evt.candidate.candidate === '') return;
				if (evt.candidate.type === 'relay') {
					console.log(`status: ${this.rtc.pc.iceConnectionState}, addr: ${evt.candidate.address}, port: ${evt.candidate.port}`)
					let serial = this.rtc.device.serial_name
					this.$session.send('candidate', {payload: evt.candidate, serial})
				}
			}
			else if (!('onicegatheringstatechange' in RTCPeerConnection.prototype)) {
				this.pc.close()
				this.pc = null
				alert('연결 중 오류가 발생하였습니다.')
			}
		})

		this.rtc.pc.addEventListener('negotiationneeded', async () => {
			console.log('negotiationneeded: ' + this.rtc.pc.signalingState)
			if (this.rtc.pc.signalingState !== 'stable') return console.log('signal: ' + this.rtc.pc.signalingState)
				const offer = await this.rtc.pc.createOffer()
				await this.localDescCreated(offer)
			})

			this.rtc.pc.addEventListener('track', evt => {
				console.log('ontrack')
				if (this.$refs.remotev.srcObject !== evt.streams[0]) {
					console.log('ontrack play')
					this.$refs.remotev.srcObject = evt.streams[0]
				}
			});
			
			this.rtc.pc.addEventListener('icecandidateerror', evt => {
				console.log('icecandidateerror: ' + evt.errorCode)
				console.log(evt)
			})

			this.$session.$on('sdp', async (data) => {
				// console.debug(`set remote desc / sdp: ${data.sdp}\ntype: ${data.type}`)
				// if (this.rtc.pc.signalingState === 'stable') return;
				await this.rtc.pc.setRemoteDescription(new RTCSessionDescription(data))
				if (this.rtc.pc.remoteDescription.type == "offer") {
					let answer = await this.rtc.pc.createAnswer()
					console.log('getAnswer')
					await this.localDescCreated(answer)
				}
			})

			this.$session.$on('candidate', async (candidate) => {
				console.log('addIceCandidate')
				// if (this.rtc.pc.signalingState !== 'stable') return console.log('signal: ' + this.rtc.pc.signalingState)
				console.log(candidate)
				try { this.rtc.pc.addIceCandidate(new RTCIceCandidate(candidate)) }
				catch (ex) { console.error(ex) }
			})

			this.$session.$on('callerror', () => {
				this.hangout()
			})
			
			this.$session.$on('hangout', () => {
				this.onVideoCall = false
				this.releaseEvent()
				// if (this.rtc.localStream) this.rtc.localStream.getTracks().forEach(track => track.stop())
				if (this.$refs.localv) this.$refs.localv.srcObject.getTracks().forEach(track => track.stop())
				this.rtc.pc.close()
			})

			const videoOption = {width: {exact: 640}, height: {exact: 480}}
			this.rtc.localStream = await navigator.mediaDevices.getUserMedia({'audio': true, 'video': videoOption})
			this.$refs.localv.srcObject = this.rtc.localStream
			this.rtc.localStream.getTracks().forEach(track => this.rtc.pc.addTrack(track, this.rtc.localStream))
			console.log('GET LOCAL TRACK')
		},
		async localDescCreated (desc) {
			await this.rtc.pc.setLocalDescription(desc)
			let senddata = {payload: this.rtc.pc.localDescription, serial: this.rtc.device.serial_name}
			this.$session.send('sdp', senddata)
		},
		prepareStartCall (detail) {
			this.checkH264Offer(20, () => {
				this.startCall(detail)
			})
		},
		releaseEvent () {
			this.$session.$off('ring')
			this.$session.$off('sdp')
			this.$session.$off('candidate')
			this.$session.$off('callerror')
			this.$session.$off('hangout')
		},
		checkH264Offer (count, cb) {
			if (count > 0) {
				let capabilities = JSON.stringify(RTCRtpSender.getCapabilities('video').codecs)
				if (capabilities.toLowerCase().includes('video/h264')) cb()
				else {
					setTimeout(() => {
						this.checkH264Offer(count - 1, cb)
					}, 1000)
				}
			}
			else {
				// fallback
				console.error('H264 Offer를 생성하지 못했습니다.')
			}
		},
		hangout () {
			console.log('hangout')
			if (this.onVideoCall) {
				this.onVideoCall = false
				this.$session.send('hangout', this.rtc.device.serial_name)
				this.releaseEvent()
				if (this.rtc) {
					if (this.$refs.localv) this.$refs.localv.srcObject.getTracks().forEach(track => track.stop())
					if (this.rtc.pc) this.rtc.pc.close()
				}
			}
		},
		videoResizeHandler () {
			// let {videoWidth, videoHeight} = this.$refs.localv
			// if (!videoWidth || !videoHeight) return;
			// videoWidth
		},
		closeDetail () {
			this.$router.go(-1)
		},
		onSearchButtonClickHandler () {
			if (this.$refs.sensortable) this.$refs.sensortable.getData()
		},
		startVideoCallDrag (evt) {
			let sx = evt.pageX, sy = evt.pageY
			let ox = this.vg.left, oy = this.vg.top
			// console.log(`sx: ${sx}, sy: ${sy}`)

			window.onmousemove = (evt) => {
				let mx = sx - evt.pageX, my = sy - evt.pageY
				// console.log(`mx: ${mx}, my: ${my}`)

				this.vg.top = oy - my
				this.vg.left = ox - mx
			}
			window.onmouseup = () => {
				console.log('onmouseup')
				window.onmousemove = () => {}
				window.onmouseup = () => {}
			}
		},

		videoPanelResizeHandler (allowed, evt) {
			let sx = evt.pageX, sy = evt.pageY
			let ow = this.vg.width, oh = this.vg.height

			window.onmousemove = (evt) => {
				let mx = sx - evt.pageX, my = sy - evt.pageY
				// console.log(`allowed: ${allowed}, mx: ${mx}, my: ${my}`)
				if (allowed & 1) this.vg.width = ow - mx
				if (allowed & 2) this.vg.height = oh - my
			}
			window.onmouseup = () => {
				console.log('onmouseup')
				window.onmousemove = () => {}
				window.onmouseup = () => {}
			}
		}
	},
	computed: {
		adult () {
			if (!this.device.birth) return ''
			let birth = moment(this.device.birth)
			return moment.duration(moment().diff(birth)).years() > 20 ? 'Adult' : 'Child'
		},
		sex () {
			if (!this.device.sex) return ''
			return ({M: 'Male', F: 'Female'})[this.device.sex]
		},
		age () {
			if (!this.device.birth) return ''
			let birth = moment(this.device.birth)
			return moment.duration(moment().diff(birth)).years()
		},
		ecg1Styles () {
			return {color: this.device.ecg_color}
		},
		spo2Styles () {
			return {color: this.device.spo2_color}
		},
		respStyles () {
			return {color: this.device.resp_color}
		},
		tempStyles () {
			return {color: this.device.temp_color}
		},
		nibpStyles () {
			return {color: this.device.nibp_color}
		},
		videoCallStyles () {
			return {
				top: this.vg.top + 'px', left: this.vg.left + 'px',
				width: this.vg.width + 'px', height: this.vg.height + 'px'
			}
		}
	},
	mounted () {
		console.log(adapter.browserDetails.browser)
		this.subscribe() 
		window.onunload = this.unsubscribe.bind(this)
		this.getPatient()

		if (this.$route.query.resv) {
			this.reservedConsult = parseInt(this.$route.query.resv, 10)
		}
	},
	beforeDestroy () {
		clearInterval(this.tick)
		this.unsubscribe()
		this.hangout()
	},
	data () {
		return {
			viewType: 'stream',
			search: {
				menu: null,
				date: moment().format('YYYY-MM-DD')
			},
			reservedConsult: null,
			onVideoCall: false,
			fullscreen: false,
			localview: false,
			vg: { top: 10, left: 10, width: 235, height: 150 },
			device: null,
			rtc: {
				pc: null,
				patient: null,
				localStream: null,
				configuration: {
					iceServers: [
						{ urls: 'turn:t-vsm.com:3478', username: 'tvsm', credential: '8YD1H0JTUA' }
					]
				}
			},

			values: {
				ecg: {st: '0', hr: '0', rr: '0', sl: '0'},
				spo2: {st: '0', s: '0', p: '0'},
				temp: {st: '0', i: '0', d: '0'},
				nibp: {st: '0', cp: '0', s: '0', m: '0', d: '0'}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	.monitor-header {
		width: 100%;
		border-bottom: 1px solid #4b4b4b;
		margin-bottom: 15px;

		display: flex;
		justify-content: space-between;
		align-items: center;

		.monitor-header-title {
			color: #909090;
			font-size: 15px;
		}
	}

	.table {
		width: 100%;
	}

	.col1 { width: 166px; }
	.col2 { }

	.td-head {
		margin-bottom: 6px;
	}

	.td-mid-lt {
		position: relative;
	}

	.td-mid-rt {
		vertical-align: top;
	}

	.td-btm-lt {
		position: relative;
	}
	// .td-btm-ct {}
	.td-btm-rt {
		text-align: center;
	}

	.head-inner {
		padding: 0 0 8px;
		display: flex;
		justify-content: space-between;
	}

	.btm-inner {
		height: 80px;
	}

	.func-wrap {
		padding: 10px 0;
		display: flex;
		flex-direction: column;
		align-items: center;
	}


	.chart-lagend {
		position: absolute;
		right: 10px;
		text-align: right;
		color: white;
		line-height: 28px;
		&.lb-ecg { top: 10px; }
		&.lb-spo { top: 200px; }
		&.lb-resp { top: 300px; }
		&.lb-temp { top: 4px; }
	}
	.chart-lagend-txt {font-size: 18px;}
	.chart-lagend-val {font-size: 40px;}

	.stat-wrap {
		display: flex;
		justify-content: space-between;
		align-items: stretch;
		.stat {
			flex: 0 0 20%;
			text-align: right;
			font-size: 12px;
			color: #bababa;
		}
	}

	.main-view {
		width: auto; height: 316px;
		overflow: hidden;
	}

	.video-call {
		position: absolute;
		min-width: 235px; min-height: 150px;
		border-radius: 5px; 
		box-shadow: 0px 5px 20px rgba(0,0,0,0.3);
		background-color: black;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		overflow: hidden;

		&.fullscreen {
			top: 0 !important; left: 0 !important;
			bottom: 0 !important; right: 0 !important;
			width: auto;

			.remotev { width: auto; height: 100%; }
		}

		&.localview {
			.video-wrap {
				transform: translateX(-235px);
			}
		}

		.video-wrap {
			display: flex;
			transition: transform 1s;
		}

		.remotev {
			flex: 1 0 100%;
			width: 100%;
		}
		
		.localv {
			flex: 1 0 100%;
			width: 100%;
		}

		.vc-btn {
			position: absolute;
			top: 5px;
			z-index: 10;
			&.vc-btn-win-move { left: 10px; }
			&.vc-btn-move { left: 60px; }
			&.vc-btn-fullscreen { right: 60px; }
			&.vc-btn-close { right: 10px; }
		}

		.resize-handle {
			position: absolute;
			z-index: 100;
			&.resize-handle-width {
				top: 0; bottom: 6px; right: 0; width: 4px; 
				cursor: ew-resize;
				background-color: transparent;
			}
			&.resize-handle-height {
				bottom: 0; left: 0; right: 6px; height: 4px; 
				cursor: ns-resize;
				background-color: transparent;
			}
			&.resize-handle-both {
				width: 6px; height: 6px;
				bottom: 0; right: 0;
				cursor: nwse-resize;
				background-color: transparent;
			}
		}
	}

	.head-name,
	.head-func { display: flex; }

	.label-top {
		height: 38px;
		background: #18191a;
		border-radius: 4px;
		display: inline-block;
		margin-right: 8px;
		text-align: center;
		display: flex;
		align-items: center;

		&.hover-item {
			cursor: pointer;
			&:hover {
				background-color: #303335;
			}
		}

		&.label-icon {
			font-size: 32px;
			padding: 0 10px !important;
		}

		&.userinfo {
			color: #ff9900;
			font-weight: bold;
			padding: 0 18px;
		}

		&.deviceinfo {
			color: #fff;
			font-weight: normal;
			
			padding: 0 14px;
		}

		&.timeinfo {
			color: #fff;
			font-weight: normal;
			padding: 0 14px;
			font-size: 12px;
		}
	}

	.col-data {
		width: 158px;
		height: 100px;
		padding: 8px;
		background: #18191a;
		border-radius: 4px;
		overflow: hidden;
		position: relative;
		margin-bottom: 6px;

		&.ecg1 { color: #70ad47; }
		&.spo2 { color: #4472c4; }
		&.resp { color: #d29500; }
		&.temp { color: #ff0066; }

		.data-icon {
			position: absolute;
			width: 16px;
			height: 16px;
			overflow: hidden;
			top: 8px;
			left: 8px;
			> i {font-size: 16px;}
		}

		.data-unit {
			position: absolute;
			height: 16px;
			line-height: 16px;
			top: 8px;
			right: 8px;
			font-size: 12px;
			text-align: center;
		}

		.data-data {
			position: absolute;
			width: 100%;
			top: 50%;
			left: 0px;
			transform: translate(0,-50%);
			font-size: 56px;
			line-height: 1em;
			font-weight: bold;
			text-align: center;
			letter-spacing: -0.05em;
			> span {font-size: 14px; font-weight: normal;}
		}

		.data-min {
			position: absolute;
			bottom: 8px;
			left: 8px;
			text-align: left;
			font-size: 12px;
		}

		.data-max {
			position: absolute;
			bottom: 8px;
			right: 8px;
			text-align: right;
			font-size: 12px;
		}

		.data-label {
			position: absolute;
			bottom: 8px;
			left: 50%;
			transform: translate(-50%,0);
			font-size: 12px;
			font-weight: bold;
			text-align: center;
		}
	}

	.bottom-toolbox {
		display: flex;
		justify-content: space-around;
	}

	.col-nibp {
		width: 563px;
		height: 100px;
		margin-right: 5px;
		background: #18191a;
		border-radius: 4px 0px 0px 4px;
		padding: 8px;
		overflow: hidden;
		position: relative;

		.nibp-icon-title {
			float: left;
			width: 64px;
			height: 84px;
			font-size: 12px;
			font-weight: bold;
			text-align: center;
			line-height: 84px;
			margin-right: 24px;
			position: relative;

			i {
				position: absolute;
				width: 24px;
				height: 24px;
				top: 0;
				left: 0;
				font-size: 24px;
				line-height: 24px;
			}
		}

		.nibp-data-wrap {
			float: left;
			width: 96px;
			height: 84px;
			margin-right: 4px;
			text-align: center;
			padding-top: 2px;
			&.mmhg,
			&.hr {
				width: 64px; 
				padding-top: 20px;
				.nibp-data { font-size: 32px; }
			}

			.nibp-data {
				width: 100%;
				font-size: 56px;
				font-weight: bold;
				line-height: 1em;
			}

			.nibp-minmax {
				width: 100%;
				font-size: 12px;
				line-height: 1em;
			}

			.nibp-label {
				width: 100%;
				font-size: 12px;
				line-height: 1em;
				padding-top: 2px;
			}
		}
	}

	.btn-nibp-refresh {
		float: left;
		width: 96px;
		height: 100px;
		margin: 0;
		padding: 0;
		border-radius: 0px 4px 4px 0px;
		margin-right: 12px;
		font-weight: bold;

		border: 0;
		background: rgb(27,31,38);
		background: linear-gradient(135deg , rgba(27,31,38,1) 0%, rgba(24,25,26,1) 100%);
		border-top: solid 1px rgba(255,255,255,0.1);
		cursor: pointer;
		outline: none;
		text-align: center;

		i {
			font-size: 64px;
		}
	}
</style>